import React from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {
  FormControl,
  FormGroup,
  Modal
} from 'react-bootstrap';

import { isPresent } from 'helpers/string_helpers';

export default class CallListRenamingModal extends React.Component {
  static propTypes = {
    callList: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string
    }).isRequired,
    shown: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
  };

  state = {
    callList: this.props.callList
  };

  canSave = () => (
    this.props.callList
    && isPresent(this.state.callList.name)
    && this.state.callList.name !== this.props.callList.name
  );

  handleChange = (e) => {
    e.preventDefault();
    const attributes = {};
    attributes[e.target.name] = e.target.value;

    this.setState((state) => {
      return {
        callList: {
          ...state.callList,
          ...attributes
        }
      };
    });
  };

  handleClose = (e) => {
    e.preventDefault();

    this.props.onClose();
  };

  handleSubmit = (e) => {
    e.preventDefault();

    axios.patch(
      `/contacts/call_lists/${this.state.callList.id}`,
      this.state.callList
    ).then((response) => {
      this.props.onClose(response.data);
    }).catch(() => {
      this.props.onClose();
    });
  }

  componentDidUpdate = (prevProps) => {
    if (this.props.callList.id !== prevProps.callList.id) {
      this.setState({ callList: this.props.callList });
    }
  }

  render() {
    return (
      <Modal show={this.props.shown} onHide={this.props.onClose}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Call List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form name="queue-form" onSubmit={this.handleSubmit}>
            <FormGroup>
              <FormControl
                name="name"
                placeholder="Name"
                type="text"
                value={this.state.callList.name}
                onChange={this.handleChange}
              />
            </FormGroup>
          </form>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-sm btn-cancel" onClick={this.handleClose}>Cancel</button>
          <button className="btn btn-sm btn-save" disabled={!this.canSave()} onClick={this.handleSubmit}>Save</button>
        </Modal.Footer>
      </Modal>
    );
  }
}
